export interface Day {
	month: Date;
	weekDays: Date[];
}
